/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  UPDATE_BANK_DETAIL: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.update.bankDetails',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'UPDATE_BANK_DETAIL' },
      },
    },
    UPDATE_BANK_DETAIL: {
      invoke: {
        id: 'updateBankDetail',
        src: 'updateBankDetail',
        onDone: {
          target: 'UPDATE_BANK_DETAIL_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'UPDATE_BANK_DETAIL_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    UPDATE_BANK_DETAIL_SUCCESS: {
      on: {
        START: { target: 'UPDATE_BANK_DETAIL' },
      },
    },
    UPDATE_BANK_DETAIL_FAILED: {
      on: {
        START: { target: 'UPDATE_BANK_DETAIL' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
